// src/views/Settings/SectionHeader.jsx
import React from 'react';

/**
 * El encabezado de una sección de configuración.
 *
 * Existe porque cada sección lo escribía por su cuenta y algunas no lo
 * escribían: Perfil tenía título y subtítulo —a 28px, con su propio CSS— y
 * Seguridad y Preferencias empezaban directo con el primer panel, así que
 * al cambiar de sección la página parecía haberse quedado a medio cargar.
 *
 * El título repite la palabra del menú a propósito. Es la confirmación de
 * que el click llegó a donde apuntaba, y es lo que el menú no puede dar
 * cuando la lista está a un lado y el contenido al otro.
 */
export default function SectionHeader({ title, subtitle }) {
  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-white">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-gray-400">{subtitle}</p>}
    </div>
  );
}
